<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  export default {
    name: 'AccessDenied',
    beforeRouteEnter(to, from, next) {
      window.previousRoute = from
      next()
    },
    methods: {
      routeBack() {
        const route = window.previousRoute || { name: 'dashboard' }
        this.$router.push(route)
      },
    },
  }
</script>
